import React from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar, Box, alpha, styled } from '@mui/material';

const DisclaimerContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5),
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
  borderRadius: '10px'
}));

const DisclaimerAvatar = styled(Avatar)(({ theme }) => ({
  display: 'inline-flex',
  width: theme.spacing(2.5),
  height: theme.spacing(2.5),
  backgroundColor: theme.palette.warning.main,
  marginRight: theme.spacing(1),
  '& span': {
    fontSize: '.7rem'
  }
}));

const DisclaimerParagraph = styled('p')(({ theme }) => ({
  marginBlock: 0,
  marginLeft: theme.spacing(3)
}));

const DisclaimerComponent = () => {
  const { t } = useTranslation();
  const items = t('Offer.Edit.Comparator.Disclaimer', { joinArrays: '\n' }).split('\n');

  return (
    <DisclaimerContainer mt={2}>
      <DisclaimerAvatar>
        <span>{t('Offer.Edit.OffersHistory.DirectSettlementCaption')}</span>
      </DisclaimerAvatar>
      {items.map((item, index) =>
        index === 0 ? <span key={index}>{item}</span> : <DisclaimerParagraph key={index}>{item}</DisclaimerParagraph>
      )}
    </DisclaimerContainer>
  );
};

export default DisclaimerComponent;
